import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";
import EdSpinner from "src/shared/components/EdSpinner";
import TextFlipper from "src/shared/components/TextFlipper";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useQuestions } from "src/context/QuestionsProvider";
import { useMemo } from "react";
import { theme } from "src/assets/theme";
import { usePatient } from "src/context/PatientProvider";

interface Props {
  onNext: () => void;
}

const EDImage = ({ onNext }: Props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const component = "message-image.ed-image";
  const title = useQuestions((q) => q.title);
  const language = usePatient((patient) => patient.profile.language);

  const words = [
    `${component}.word.0`,
    `${component}.word.1`,
    `${component}.word.2`,
    `${component}.word.3`,
    `${component}.word.4`,
    `${component}.word.5`,
  ];

  const styledTitle = useMemo(() => {
    const highlightedWord =
      language === "es"
        ? "Jefe Max"
        : language === "pt"
        ? "Chefe Max"
        : "Boss Max";
    const [before, match, after] = title.split(
      new RegExp(`(${highlightedWord})`, "i")
    );

    return (
      <Typography variant={"h5"} fontWeight={700} component={"span"}>
        {before}
        <span style={{ color: theme.palette.secondary.main }}>{match}</span>
        {after}
      </Typography>
    );
  }, [language, title]);

  return (
    <Stack gap="20px">
      <Typography>{styledTitle}</Typography>
      <WhiteCard
        onClick={() => onNext()}
        sx={{
          background:
            "linear-gradient(180deg, #F8F8F8 0%, rgba(0, 181, 184, 0.55) 100%)",
        }}
        gap={3}
      >
        <Typography color="#0E888A" variant="h5" fontWeight={600}>
          {t(`${component}.header`, "Boss Max")}
        </Typography>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <WhiteCard
            sx={{ background: "#ffffff", padding: "12px" }}
            width={"40%"}
          >
            <Typography variant="body2" textAlign={"center"}>
              {t(
                `${component}.text-card.1`,
                "Works great for both planned and spontaneous sex"
              )}
            </Typography>
          </WhiteCard>
          <WhiteCard
            sx={{ background: "#ffffff", padding: "12px" }}
            textAlign={"center"}
            width={"40%"}
          >
            <Typography variant="body2">
              {t(
                `${component}.text-card.2`,
                "Dissolves on your tongue for quick, easy use"
              )}
            </Typography>
          </WhiteCard>
        </Stack>
        <Box
          sx={{
            position: "relative",
            width: isMobile ? "300px" : "400px",
            height: isMobile ? "300px" : "400px",
            mx: "auto",
            // mt: 3,
          }}
        >
          <EdSpinner size={isMobile ? 300 : 400} />
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Stack width={300} alignItems={"center"}>
              <Typography fontWeight={600} variant="h4">
                {t(`${component}.header`)}
              </Typography>
              <TextFlipper flippedWords={words} />
            </Stack>
          </Box>
        </Box>
      </WhiteCard>
    </Stack>
  );
};

export default EDImage;
